<!-- ===== Header ===== -->
<div class="card shadow-sm border-0 mb-3">
  <div class="card-body py-3">
    <h4 class="card-title mb-0 fw-semibold">
      {{ 'MENU.DASHBOARD.items' | translate }}
    </h4>
  </div>

<!-- ===== Form Card ===== -->
<div class="card shadow-sm border-0">
  <div class="card-body">

    <form (ngSubmit)="onSubmit()" enctype="multipart/form-data">

      <div class="row justify-content-center">
        <div class="col-lg-8">



    <div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang == 'ar' ? 'التصنيف' : 'Category' }}
  </label>

  <select
    class="form-control"
    [(ngModel)]="formData.category_id"
    name="category_id"
    required
  >
    <option [ngValue]="null" disabled>
      {{ lang == 'ar' ? 'اختر التصنيف' : 'Select Category' }}
    </option>

    <option *ngFor="let cat of arrCoupons" [ngValue]="cat.id">
      {{ cat.name }}
    </option>
  </select>

  <small class="text-danger" *ngIf="errors?.category_id">
    {{ errors.category_id[0] }}
  </small>
</div>

 <div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang == 'ar' ? 'العنوان' : 'Title' }}
  </label>

  <input
    type="text"
    class="form-control"
    [(ngModel)]="formData.title"
    name="title"
  />

  <small class="text-danger" *ngIf="errors?.title">
    {{ errors.title[0] }}
  </small>
</div>

  <div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang == 'ar' ? 'المحتوى' : 'Content' }}
  </label>

  <textarea
    class="form-control"
    rows="4"
    [(ngModel)]="formData.content"
    name="content"
    required
  ></textarea>

  <small class="text-danger" *ngIf="errors?.content">
    {{ errors.content[0] }}
  </small>
</div>

<div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang == 'ar' ? 'العدد' : 'Count' }}
  </label>

  <input
    type="number"
    min="1"
    class="form-control"
    [(ngModel)]="formData.count"
    name="count"
  />

  <small class="text-danger" *ngIf="errors?.count">
    {{ errors.count[0] }}
  </small>
</div>

<div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang == 'ar' ? 'الترتيب' : 'Order' }}
  </label>

  <input
    type="number"
    min="0"
    class="form-control"
    [(ngModel)]="formData.order"
    name="order"
  />

  <small class="text-danger" *ngIf="errors?.order">
    {{ errors.order[0] }}
  </small>
</div>
          <!-- Submit -->
          <div class="d-flex justify-content-end">
            <button type="submit" class="btn btn-primary px-4">
              {{ 'MENU.DASHBOARD.Add' | translate }}
            </button>
          </div>

        </div>
      </div>

    </form>

  </div></div>

</div>
